/*
 * @Author: zhujian
 * @Date: 2018-02-26 17:51:03
 * @Last Modified by: zhujian
 * @Last Modified time: 2019-09-17 13:13:06
 */
import React from 'react';
import Bus from '../../core/bus';

class Voice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      info: {},
      list: [],
      palying: false,
      times: 0 // 点击次数
    };
  }

  componentDidMount() {
    console.log('进入voice')
    const audio = this.refs.audio;
    const isPlay = () => {
      console.log(8888, 'isPlay')
      audio.muted = true;
      const p = audio.play();

      if (p !== undefined) {
        p.then(() => {
          audio.muted = false;
          audio.pause();

          setTimeout(() => {
            audio.play()
          }, 100);
        }).catch(e => {
          console.log('err', e)
        })
      }
      // audio.pause();
    };
    const documentEl = document.documentElement;
    // 解决苹果ipad点名没有声音的bug
    if (!this.state.times) {
      documentEl.addEventListener('click', isPlay);
      const _this = this;
      this.setState(
        {
          times: _this.state.times++
        },
        () => {
          documentEl.removeEventListener('click', isPlay);
        }
      );
    }

    audio.pause();
    audio.addEventListener('ended', () => {
      console.log('onstop');
      let list = this.state.list;
      if (list.length) {
        const info = list.shift();
        // console.log('list', list, 'info')
        this.setState({ info, list }, () => {
          isPlay()
        });
      } else {
        this.setState({
          playing: false
        });
      }
    });

    Bus.bind('playVoice', infos => {
      let list = this.state.list.concat(infos);
      if (!this.state.playing) {
        const info = list.shift();
        // console.log('list', list, 'info')
        this.setState({ info, list, playing: true }, () => {
          isPlay()
        });
      } else {
        // console.log('list', list)
        this.setState({
          list
        });
      }
    });
  }

  render() {
    return (
      <div style={{ position: 'absolute', left: '-5000' }}>
        <audio src={this.state.info.url} ref='audio' muted></audio>
      </div>
    );
  }
}

export default Voice;
